import React from 'react';

const CountryBlockModal = ({ country, onBypass, onBack }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
      <div className="bg-white rounded-2xl shadow-xl p-6 w-[90%] max-w-md text-center">
        <h2 className="text-2xl font-bold text-red-600 mb-4">Access Restricted</h2>
        <p className="mb-4 text-gray-700">
          We are very sorry,you can't access our shop.Currently our services are only available in <strong>India</strong>.
        </p>
        {country && (
          <p className="mb-2 text-sm text-gray-600">
            Your detected country: <strong>{country}</strong>
          </p>
        )}
        <div className="mt-6 flex justify-center gap-4">
          <button
            onClick={onBypass}
            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm"
          >
            Browse as India
          </button>
          <button
            onClick={onBack}
            className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-2 rounded-lg text-sm"
          >
            Go Back
          </button>
        </div>
        <p className="text-xs text-gray-500 mt-4">
          Your location is only used temporarily in your browser and is never stored or transmitted elsewhere.
        </p>
      </div>
    </div>
  );
};

export default CountryBlockModal;
